type StoredToken = { AccessToken?: string };

/**
 * Reads the auth token shape from localStorage and returns the access token.
 * Corrupt JSON and missing keys safely collapse to `undefined`.
 */
export function getAccessToken(storageKey = "token"): string | undefined {
  const tokenString = localStorage.getItem(storageKey);
  if (!tokenString) return undefined;
  try {
    const parsed = JSON.parse(tokenString) as StoredToken;
    return parsed.AccessToken;
  } catch {
    return undefined;
  }
}
